import type { Route } from "@sg-protect/federation-runtime";
import { redirect } from "react-router";
import { AuthenticatedLayout } from "./components/layout/AuthenticatedLayout.tsx";
import { Routes } from "./constants.ts";

export const publicRoutes: Route[] = [
    {
        path: Routes.missingSharegateLicense,
        $visibility: "public",
        lazy: () => import("./pages/missing-sharegate-license.tsx"),
        handle: {
            trackingName: "Missing ShareGate License"
        }
    },
    {
        path: Routes.microsoft.tenantAccessRequest,
        $visibility: "public",
        lazy: () => import("./pages/microsoft/tenant-access-request.tsx"),
        handle: {
            trackingName: "Tenant Access Request"
        }
    }
];

export const privateRoutes: Route[] = [
    {
        element: <AuthenticatedLayout />,
        children: [
            {
                path: Routes.assessment,
                lazy: () => import("./pages/landing-page.tsx"),
                handle: {
                    trackingName: "Landing Page"
                }
            },
            {
                path: Routes.microsoft.wizard,
                lazy: () => import("./pages/microsoft/wizard.tsx"),
                handle: {
                    trackingName: "Microsoft Migrate Wizard"
                }
            },
            {
                path: Routes.microsoft.assessment,
                lazy: () => import("./pages/microsoft/assessment.tsx"),
                children: [
                    {
                        index: true,
                        loader: () => redirect("./overview")
                    },
                    {
                        path: Routes.microsoft.overview,
                        lazy: () => import("./pages/microsoft/tabs/assessment.overview.tsx"),
                        handle: {
                            trackingName: "Microsoft Migrate Overview"
                        }
                    },
                    {
                        path: Routes.microsoft.exchange,
                        lazy: () => import("./pages/microsoft/tabs/assessment.exchange.tsx"),
                        handle: {
                            trackingName: "Microsoft Migrate Exchange"
                        }
                    },
                    {
                        path: Routes.microsoft.sharepoint,
                        lazy: () => import("./pages/microsoft/tabs/assessment.sharepoint.tsx"),
                        handle: {
                            trackingName: "Microsoft Migrate SharePoint"
                        }
                    },
                    {
                        path: Routes.microsoft.onedrive,
                        lazy: () => import("./pages/microsoft/tabs/assessment.onedrive.tsx"),
                        handle: {
                            trackingName: "Microsoft Migrate OneDrive"
                        }
                    },
                    {
                        path: Routes.microsoft.teams,
                        lazy: () => import("./pages/microsoft/tabs/assessment.teams.tsx"),
                        handle: {
                            trackingName: "Microsoft Migrate Teams"
                        }
                    },
                    {
                        path: Routes.microsoft.users,
                        lazy: () => import("./pages/microsoft/tabs/assessment.users.tsx"),
                        handle: {
                            trackingName: "Microsoft Migrate Users"
                        }
                    }
                ]
            },
            {
                path: Routes.google.wizard,
                lazy: () => import("./pages/google/wizard.tsx"),
                handle: {
                    trackingName: "Google Migrate Wizard"
                }
            },
            {
                path: Routes.google.assessment,
                lazy: () => import("./pages/google/assessment.tsx"),
                children: [
                    {
                        index: true,
                        loader: () => redirect("./overview")
                    },
                    {
                        path: Routes.google.overview,
                        lazy: () => import("./pages/google/tabs/assessment.overview.tsx"),
                        handle: {
                            trackingName: "Google Migrate Overview"
                        }
                    },
                    {
                        path: Routes.google.drives,
                        lazy: () => import("./pages/google/tabs/assessment.drives.tsx"),
                        handle: {
                            trackingName: "Google Migrate Drives"
                        }
                    },
                    {
                        path: Routes.google.mailboxes,
                        lazy: () => import("./pages/google/tabs/assessment.mailboxes.tsx"),
                        handle: {
                            trackingName: "Google Migrate Mailboxes"
                        }
                    }
                ]
            }
        ]
    }
];
